import type { Pinia, Store } from "pinia"
import type { App } from "vue"

import {
  createPinia,
  getActivePinia,
} from "pinia"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"

import { setupPiniaSentry } from "@/sentry"

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>
}

const store = createPinia()

export function setupStore(app: App<Element>) {
  store.use(piniaPluginPersistedstate)
  setupPiniaSentry(store)
  app.use(store)
}

export function clearStore() {
  const pinia = getActivePinia() as ExtendedPinia

  if (!pinia) return
  pinia._s.forEach(store => {
    store.$reset()
  })
}

export { store }
